/* global ga, lib */
import calendarPrices from '@PROJECT_ROOT/assets/mobile/js/calendarPrices';
import commentReviews from '@PROJECT_ROOT/assets/mobile/js/facilityUnitComment';
import createSwipeGallery from '@PROJECT_ROOT/assets/mobile/js/swipeGallery';
import createTabs from '@PROJECT_ROOT/assets/shared/js/tabs';
import fetchStateFromHtml from '@PROJECT_ROOT/assets/shared/js/fetchStateFromHtml';
import loadMapTabContent from '@PROJECT_ROOT/assets/mobile/js/loadMapTabContent';
import toggleExteriorSizeVisibility from '@PROJECT_ROOT/assets/mobile/js/privateAccommodation/toggleExteriorSizeVisibility';
import tooltip from '@PROJECT_ROOT/assets/mobile/js/tooltip';
import { heightChanged, legacyHeightChanged } from '@PROJECT_ROOT/assets/shared/js/frameToPartnerMessageTypes';

$(() => {
    const state = fetchStateFromHtml();

    tooltip.init();
    calendarPrices.init(state.calendarPrices);
    lib.accordions.init(state.accordions);
    lib.shortlist.init(state.shortlist);

    createGallery(state.galleryImages);

    createTabs([
        { headingSelector: '#infoTabHeading', contentSelector: '#infoTabContent' },
        {
            headingSelector: '#mapTabHeading',
            contentSelector: '#mapTabContent',
            onTabOpen() {
                const mapContainer = document.getElementById('mapCanvas');

                loadMapTabContent(mapContainer, Promise.resolve(state.googleMap));
            },
        },
        {
            headingSelector: '#reviewTabHeading',
            contentSelector: '#reviewTabContent',
            onFirstTabOpen() {
                commentReviews(state.commentReview);
            },
        },
    ]);

    const $moreInfoBtn = $('.js-moreInfoBtn');
    const $moreInfos = $('.js-moreInfo ul');
    const heightMin = '310px';

    moreInfo($moreInfoBtn, $moreInfos, heightMin);

    toggleExteriorSizeVisibility(false);

    window.addEventListener('orientationchange', () => {
        const resizeListener = () => {
            $moreInfos.addClass('open');
            $moreInfos.css('maxHeight', '100%');
            const newHeight = $('.js-moreInfo').outerHeight();
            $moreInfoBtn.off('click');
            setTimeout(moreInfo($moreInfoBtn, $moreInfos, heightMin, newHeight), 200);
            $moreInfos.removeClass('open');
            $moreInfoBtn.removeClass('active');
            window.removeEventListener('resize', resizeListener);
        };

        window.addEventListener('resize', resizeListener);
    });

    // Klikom na ocjenu objekta aktivira se tab Ocjene gostiju
    $(document).on('click', '.js-guestRate', () => $('#reviewTabHeading').trigger('click'));

    sendGoogleAnaliticsEventOnCalendarClick();
});

function sendGoogleAnaliticsEventOnCalendarClick() {
    $('#calendarTable').on('click', () => sendGoogleAnaliticsEvent('Prezentacija', 'KalendarNoAction', ''));
}

function sendGoogleAnaliticsEventOnNavigateClick() {
    sendGoogleAnaliticsEvent('Prezentacija', 'Galerija', 'listanje-klik');
}

function sendGoogleAnaliticsEventOnSwipe() {
    sendGoogleAnaliticsEvent('Prezentacija', 'Galerija', 'listanje-slide');
}

function sendGoogleAnaliticsEventOnFullscreen() {
    sendGoogleAnaliticsEvent('Prezentacija', 'Galerija', '');
}

function sendGoogleAnaliticsEvent(category, action, label) {
    if (typeof (ga) !== 'undefined') {
        ga('send', { hitType: 'event', eventCategory: category, eventAction: action, eventLabel: label });
    }
}

function moreInfo($moreInfoBtn, $moreInfos, heightMin, newHeight) {
    const heightMax = newHeight || $('.js-moreInfo').outerHeight();

    setHidden($moreInfos, heightMin);

    $moreInfoBtn.on('click', (e) => {
        $moreInfoBtn.toggleClass('active');
        $moreInfos.toggleClass('open');

        if ($moreInfos.css('maxHeight') === heightMin) {
            $moreInfos.animate({ maxHeight: heightMax }, 200, 'swing', postHeightChangedMessageToFrameParent);
        } else {
            $moreInfos.animate({ maxHeight: heightMin }, 200, 'swing', postHeightChangedMessageToFrameParent);
        }

        e.stopPropagation();
    });
}

function postHeightChangedMessageToFrameParent() {
    window.parent.postMessage(heightChanged(), '*');
    window.parent.postMessage(legacyHeightChanged(document), '*');
}

function setHidden($moreInfos, heightMin) {
    $moreInfos.css('maxHeight', heightMin);
}

function createGallery(galleryImages) {
    const gallery = createSwipeGallery('#gallery', galleryImages);

    gallery.onNavigateClick(sendGoogleAnaliticsEventOnNavigateClick);
    gallery.onFullscreen(sendGoogleAnaliticsEventOnFullscreen);
    gallery.onSwipe(sendGoogleAnaliticsEventOnSwipe);
}
